// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QNHa55CPBX6gv_ {
  display: flex;
  position: relative;
  flex-direction: column;
}
.a25iUYtX4DdGbe {
  margin-top: -8px;
  margin-bottom: -24px;
}
@media only screen and (max-width: 750px) {
  .a25iUYtX4DdGbe {
    margin-bottom: 0;
  }
}
.hl2XIttzg_LUv_ {
  flex: 1 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"workspaceBoardsPageLayout": `QNHa55CPBX6gv_`,
	"templatePicker": `a25iUYtX4DdGbe`,
	"boardTileContainer": `hl2XIttzg_LUv_`
};
export default ___CSS_LOADER_EXPORT___;
